<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";

const cardTitle = ref("");
const route = useRoute();
const breadcrumbPaths = ref<string[]>([]);

// Set cardTitle from query params
cardTitle.value = Array.isArray(route.query.title)
  ? route.query.title[0] || "" // Use the first element if it's an array
  : route.query.title || "";

// Watch the route object for changes and update breadcrumbs
watch(
  route,
  (newRoute) => {
    breadcrumbPaths.value = newRoute.matched.map((matchedRoute) => {
      let path = matchedRoute.path;

      // Replace dynamic segments (like ":id") with actual values from route params
      Object.entries(route.params).forEach(([key, value]) => {
        path = path.replace(`:${key}`, value as string);
      });

      // Remove numerical segments (like "/2", "/123")
      path = path.replace(/\/\d+$/, "");

      // Replace "id-card" with "ID Card" for readability
      path = path.replace(/id-card/g, "");

      return path;
    });
  },
  { immediate: true }
);

// Format breadcrumbs for display
const formattedBreadcrumbs = computed(() => {
  return breadcrumbPaths.value
    .map((path) => path.replace(/^\//, "").replace(/-/g, " ")) // Clean up path formatting
    .join(" / "); // Join paths with a separator
});
</script>


<template>
  <div v-if="route.path != '/'">
    <div class="breadcrumb-container">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb justify-content-start text-capitalize">
          <!-- Iterate through breadcrumbPaths -->
          <li v-for="(path, index) in breadcrumbPaths" :key="index" class="breadcrumb-item">
            <router-link to="/" class="breadcrumb-link">
              Home/ 
            </router-link>
            <router-link
              v-if="index !== breadcrumbPaths.length - 1"
              :to="path"
              class="breadcrumb-link"
            >
              {{ path.replace(/^\//, "").replace(/-/g, " ") }}
            </router-link>
<!--            
            <span v-else class="breadcrumb-item active">
              {{ path.replace(/^\//, "").replace(/-/g, " ") }}
            </span> -->
            <span class="breadcrumb-item active"> {{ path.replace(/^\//, "").replace(/-/g, " ") }} {{cardTitle}}</span>
            <span v-if="index !== breadcrumbPaths.length - 1" class="breadcrumb-arrow">/</span>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<style scoped>
.breadcrumb-container {
  position: absolute;
  top: 70px;
  left: 50px;
  width: 100%;
  /* background: rgba(255, 255, 255, 0.9);  */
  padding: 10px;
  z-index: 1000; /* Ensure it's on top */
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}

.breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 0;
  display: inline-flex;
}

.breadcrumb-item {
  display: inline;
  margin-right: 5px;
  font-size: 16px;
  transition: transform 0.3s, color 0.3s;
}

.breadcrumb-arrow {
  color: #6c757d;
  font-size: 16px;
  margin: 0 5px;
}

.breadcrumb-link {
  color: rgb(182, 226, 20);
  text-transform: capitalize;
  text-decoration: none;
  transition: color 0.3s;
}

.breadcrumb-link:hover {
  color: #007bff;
}

.breadcrumb-item.active {
  color: #00ede1;
  font-weight: bold;
}



/* Responsive Adjustments */
@media (max-width: 768px) {
  .breadcrumb-container {
    font-size: 12px;
    padding: 6px 10px;
  }
  /* .breadcrumb-item {
    font-size: 12px;
  }
  .breadcrumb-arrow {
    font-size: 12px;
  } */
}

@media (max-width: 480px) {
  .breadcrumb-container {
    font-size: 11px;
    padding: 4px 8px;
    top: 52px;
  left: 10px;
  width: 54%;
  }
  /* .breadcrumb-item {
    font-size: 11px;
  }
  .breadcrumb-arrow {
    font-size: 11px;
  } */
}
</style>
